// GENERATED DO NOT EDIT
import {MuWidget} from 'mu-widget/lib/MuWidget';
import * as barMeter from '..//components/BarMeter';
import * as commonListItem from '..//components/CommonListItem';
import * as infiniteSelector from '..//components/InfiniteSelector';
import * as uiCalendar from '..//components/UiCalendar';
import * as uiClientData from '..//components/UiClientData';
import * as uiComponentPreview from '..//components/UiComponentPreview';
import * as uiDayFoodPlan from '..//components/UiDayFoodPlan';
import * as uiInput from '..//components/UiInput';
import * as uiActivityVariantSelector from '..//components/front/UiActivityVariantSelector';
import * as uiAddActivity from '..//components/front/UiAddActivity';
import * as uiApp from '..//components/front/UiApp';
import * as uiAppClientDataBanner from '..//components/front/UiAppClientDataBanner';
import * as uiEditActivity from '..//components/front/UiEditActivity';
import * as uiEditNote from '..//components/front/UiEditNote';
import * as uiJournalActivityList from '..//components/front/UiJournalActivityList';
import * as uiMenu from '..//components/front/UiMenu';
import * as uiNotLoggedInfo from '..//components/front/UiNotLoggedInfo';
import * as uiNotifyBanner from '..//components/front/UiNotifyBanner';
import * as uiNutriInfo from '..//components/front/UiNutriInfo';
import * as uiSign from '..//components/front/UiSign';
import * as uiVisual from '..//components/front/UiVisual';


export function registerFrontComponents() {
    MuWidget.registerAll(
		barMeter,
		commonListItem,
		infiniteSelector,
		uiCalendar,
		uiClientData,
		uiComponentPreview,
		uiDayFoodPlan,
		uiInput,
		uiActivityVariantSelector,
		uiAddActivity,
		uiApp,
		uiAppClientDataBanner,
		uiEditActivity,
		uiEditNote,
		uiJournalActivityList,
		uiMenu,
		uiNotLoggedInfo,
		uiNotifyBanner,
		uiNutriInfo,
		uiSign,
		uiVisual,

    );
}
